// Utilidad para manejar iconos SVG dinámicamente
// Este archivo se genera automáticamente con el script generateIconList.js
// Para regenerar: npm run generate-icons

// Lista de iconos SVG disponibles en la carpeta public/images/iconos/
// Generada automáticamente el 2025-11-08T22:47:06.052Z
export const SVG_ICONS = [
  'Check',
  'abajo',
  'acciones',
  'actualizar',
  'adelante',
  'ajustes',
  'arriba',
  'atras',
  'bloqueado',
  'calendario',
  'camara',
  'campana',
  'cantinero',
  'carpeta-mas',
  'carrito',
  'casa',
  'cerrar',
  'chrome',
  'clip',
  'compartir',
  'configuraciones',
  'corazon',
  'cubiertos',
  'divisa',
  'editar',
  'equipo',
  'estrella',
  'eventos',
  'filtros',
  'grafico',
  'grilla',
  'guardar',
  'idioma',
  'imagen',
  'inventario',
  'lista',
  'luna',
  'lupa',
  'mas',
  'mas-horizontal',
  'mas-vertical',
  'menos',
  'mensaje',
  'menu',
  'mundo',
  'ojo',
  'ojo-cerrado',
  'panel',
  'pedidos',
  'qr',
  'signo-dolar',
  'sol',
  'tarjeta-credito',
  'teclado',
  'telefono',
  'ubicacion',
  'usuario',
  'vasos'
];

// Función para verificar si un nombre de icono es válido
export const isValidSvgIcon = (iconName: string): boolean => {
  return SVG_ICONS.includes(iconName);
};

// Función para obtener todos los iconos disponibles
export const getAvailableIcons = (): string[] => {
  return [...SVG_ICONS];
};

// Función para verificar si un string es un emoji
export const isEmoji = (str: string): boolean => {
  return str.length === 1 && /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/u.test(str);
};

// Función para obtener la URL de un icono SVG
export const getSvgIconUrl = (iconName: string): string => {
  return `/images/iconos/${iconName}.svg`;
};
